import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["clientExamples", "features", "offering", "pricing", "provider", "reviewSummary", "screenshots", "support"],
  _excluded2 = ["clientExamples", "features", "offering", "pricing", "provider", "reviewSummary", "screenshots", "support"];
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import Pricing from 'marketplace-ui-common/records/Pricing';
import Screenshot from 'marketplace-ui-common/records/Screenshot';
import ReviewSummary from 'marketplace-ui-reviews/records/ReviewSummary';
import ClientExample from './ClientExample';
import SupportInfo from './SupportInfo';
import AssetFeature from './AssetFeature';
import AssetProviderDetailsResponse from './AssetProviderDetailsResponse';
import { assetBaseDetailsResponseDefaults, AssetOffering } from './AssetBaseDetailsResponse';
const themeDetailsResponseDefaults = Object.assign({}, assetBaseDetailsResponseDefaults, {
  businessTypes: [],
  clientExamples: [],
  pageFeatures: [],
  pageTypes: []
});
export default class ThemeDetailsResponse extends createImmutableObjectClass(themeDetailsResponseDefaults, {
  fromJSON: _ref => {
    let {
        clientExamples,
        features,
        offering,
        pricing,
        provider,
        reviewSummary,
        screenshots,
        support
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return cleanObject(Object.assign({
      clientExamples: clientExamples.map(clientExample => new ClientExample(clientExample)),
      features: features.map(feature => new AssetFeature(feature)),
      offering: new AssetOffering(offering),
      pricing: new Pricing(pricing),
      provider: new AssetProviderDetailsResponse(provider),
      reviewSummary: new ReviewSummary(reviewSummary),
      screenshots: screenshots.map(screenshot => new Screenshot(screenshot)),
      support: support ? new SupportInfo(support) : null
    }, rest));
  },
  toJSON: _ref2 => {
    let {
        clientExamples,
        features,
        offering,
        pricing,
        provider,
        reviewSummary,
        screenshots,
        support
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      clientExamples: clientExamples.map(clientExample => clientExample.toJSON()),
      features: features.map(feature => feature.toJSON()),
      offering: offering.toJSON(),
      pricing: pricing.toJSON(),
      provider: provider.toJSON(),
      reviewSummary: reviewSummary.toJSON(),
      screenshots: screenshots.map(screenshot => screenshot.toJSON()),
      support: support ? support.toJSON() : null
    }, rest);
  }
}) {}